  document.addEventListener('DOMContentLoaded', function () {
    const subNavLinks = document.querySelectorAll('.mega-subnav-link');
    subNavLinks.forEach((link) => {
      link.addEventListener('mouseenter', function () {
        const container = this.closest('.mega-split-layout');
        if (!container) return;
        container.querySelectorAll('.mega-subnav-link').forEach((l) => l.classList.remove('is-active'));
        this.classList.add('is-active');
        container.querySelectorAll('.tab-panel').forEach((panel) => panel.classList.remove('is-active'));
        const targetId = this.getAttribute('data-target');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });

    const searchBtn = document.querySelector('.js-search-toggle');
    const searchBar = document.getElementById('header-search-bar');
    const searchInput = searchBar ? searchBar.querySelector('.search-input') : null;

    if (searchBtn && searchBar) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        searchBar.classList.toggle('is-open');
        if (searchBar.classList.contains('is-open') && searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
      });

      document.addEventListener('click', function (e) {
        if (!searchBar.contains(e.target) && !searchBtn.contains(e.target)) {
          searchBar.classList.remove('is-open');
        }
      });
    }

    function updateCartCount() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const bubbles = document.querySelectorAll('.cart-count-bubble, .mobile-cart-count-bubble');

          bubbles.forEach((bubble) => {
            bubble.textContent = cart.item_count;
            if (cart.item_count > 0) {
              bubble.classList.remove('is-hidden');
              bubble.style.display = 'flex';
            } else {
              bubble.classList.add('is-hidden');
              bubble.style.display = 'none';
            }
          });
        })
        .catch((error) => console.error('Error fetching cart:', error));
    }

    const originalFetch = window.fetch;
    window.fetch = function () {
      return originalFetch.apply(this, arguments).then((response) => {
        if (
          response.url.includes('/cart/add') ||
          response.url.includes('/cart/change') ||
          response.url.includes('/cart/update') ||
          response.url.includes('/cart/clear')
        ) {
          setTimeout(updateCartCount, 300);
        }
        return response;
      });
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        if (
          typeof url === 'string' &&
          (url.includes('/cart/add') ||
            url.includes('/cart/change') ||
            url.includes('/cart/update') ||
            url.includes('/cart/clear'))
        ) {
          setTimeout(updateCartCount, 300);
        }
      });
      originalOpen.apply(this, arguments);
    };

    const allMegaLinks = document.querySelectorAll('.mega-menu-wrapper a');

    allMegaLinks.forEach((link) => {
      link.addEventListener('click', function () {
        const wrapper = this.closest('.mega-menu-wrapper');
        const navItem = this.closest('.nav-item');
        if (wrapper) {
          wrapper.style.display = 'none';
          if (navItem) navItem.classList.remove('hover');
          setTimeout(() => {
            wrapper.style.display = '';
          }, 500);
        }
        this.blur();
      });
    });
  });